import * as React from 'react';
export const ExponentLogo = () => React.createElement("img", { src: "./images/exponent_logo@1x.png", srcSet: "./images/exponent_logo@1x.png 1x, ./images/exponent_logo@2x.png 2x", alt: "Chemix" });
export const Logo64 = () => React.createElement("img", { src: "./images/64.png", className: "mb-1", srcSet: "./images/64.png 1x,\n        ./images/128.png 2x" });
